import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Svg } from "../svg/Svg";
export const ParagraphIcon = React.forwardRef((props, ref) => (_jsx(Svg, { "data-testid": "ParagraphIcon", ...props, ref: ref, children: _jsx("path", { fill: "currentColor", d: "M15.5,0a.5.5,0,0,1,.09.992L15.5,1H13V15.5a.5.5,0,0,1-.992.09L12,15.5V1H8.5V15.5a.5.5,0,0,1-.992.09L7.5,15.5V10H5A5,5,0,0,1,4.783.005L5,0Zm-8,9V1H5a4,4,0,0,0-.2,7.995L5,9Z" }) })));
ParagraphIcon.displayName = "ParagraphIcon";
